<template>
  <div class="meetManan">
    <cq-header headertext="MEET MANAN THE GO-TO-MAN FOR GAINFUL GROWTH"></cq-header>

    <cqtextimagesection direction = "L" :imagesrc="images.meetmanan" showBackgroundImage="true">
        
        <h5> <b class="red"> #NoGyanOnlyGain </b> </h5>
        <cq-paratext> Manan has been a Game Changer and a Life Changer. His core competency says it all. <br> <h6> <b class="red"> PRODUCTIVITY, IMPLEMENTATION &amp; LEADERSHIP. </b> </h6> </cq-paratext>
        <cq-paratext> He has a unique talent of unleashing potential by making individuals &amp; teams accountable to their own selves &amp; thereby produce Gains &amp; Tangible Results in a time-bound manner as a habit. </cq-paratext>
        <cq-paratext> He brings crystal-clear clarity and single-minded focus in planning projects and creating work-breakdown structures for precise and effective execution. </cq-paratext>
        
    </cqtextimagesection>
  </div>
</template>

<script>
import CQHeader from '../../components/ui/CQHeader.vue'
import CQPara from '../../components/ui/CQPara.vue'
import CQTextImageSection from '../../components/ui/CQTextImageSection.vue'

// Import Image
import meetmanan from '../../assets/image/mv/meetmanan.png'

export default {
    components:{
        'cq-header' : CQHeader,
        'cq-paratext' : CQPara,
        'cqtextimagesection': CQTextImageSection,
    },
    data() {
    return {
        images: { 
            meetmanan,
        }
    }
  }

}
</script>

<style scoped>
  .meetManan >>> .grey{
    background-image: #fff !important;
  }
  .meetManan >>> .red{
    color: var(--primary-color);
  }

  .meetManan >>> h5{
    font-family: 'Seravek-Medium'; 
    font-size: 24px;
    padding-bottom: 3%;
  }

  .meetManan >>> h6{
    font-size: 18px;
    font-family: 'Seravek-Medium'; 
  }

  /* p{
    font-size: 19px;
    font-family: 'Seravek-Light';
  } */

  .meetManan >>> .random-img{
    padding-top: 0 !important;
    /* margin-top: -65px; */
    margin-bottom: 30px;
    max-width: 85%;
    z-index: 1;
  }

  /* Desktop View */
@media only screen and (min-width: 992px){
  

  .meetManan >>> .behind-header{
    margin-bottom: 0 !important;
    z-index: 3;
  }

  .meetManan >>> .mdh1 {
    padding-top: 80px;
  }
}

@media only screen and (max-width: 992px){
  .meetManan >>> .behind-header{
    margin-top: 0 !important;
  }
  .meetManan >>> h5{
    padding-left: 0px;
  }

  .meetManan >>> .random-img{
    margin-top: -50px;
  }
}
</style>